import React from "react";
import BaseLayout from "@/Layouts/BaseLayout";
import {isDesktop, isMobile} from "@/Helpers/Function";
import Minima from "@/Pages/Collections/Minima";
import Story from "@/Pages/Collections/Story";
import Wish from "@/Pages/Collections/Wish";
import NorthernLights from "@/Pages/Collections/NorthernLights";
import OceanDesktop from "@/Pages/Collections/OceanDesktop";
import OceanMobile from "@/Pages/Collections/OceanMobile";
import EnvieMobile from "@/Pages/Collections/EnvieMobile";
import EnvieDesktop from "@/Pages/Collections/EnvieDesktop";
import One from "@/Pages/Collections/One";
import Line from "@/Pages/Collections/Line";
import Awake from "@/Pages/Collections/Awake";
import PlatinaArt from "@/Pages/Collections/PlatinaArt";
import Pets from "@/Pages/Collections/Pets";
import StandardTemplateCollection from "@/Pages/Collections/StandardTemplateCollection";
import {ViewItemBatcherProvider} from "@/Context/ViewItemBatcherContext";
import "@/Pages/Collections/scss/collection-detailed.scss";

const Index = (props) => {
    const {template = ''} = props;

    const DetailedStart = () => {
        switch (template) {
            case 'standard':
                return <StandardTemplateCollection {...props} />;
            case 'platina-pets':
                return <ViewItemBatcherProvider><Pets {...props} /></ViewItemBatcherProvider>;
            case 'platina-art':
                return <ViewItemBatcherProvider><PlatinaArt {...props} /></ViewItemBatcherProvider>;
            case 'platina-awake':
                return <ViewItemBatcherProvider><Awake {...props} /></ViewItemBatcherProvider>;
            case 'platina-line':
                return <ViewItemBatcherProvider><Line {...props} /></ViewItemBatcherProvider>;
            case 'platina-one':
                return <ViewItemBatcherProvider><One {...props} /></ViewItemBatcherProvider>;
            case 'envie-dete':
                return <>
                    {isMobile() ?
                        <EnvieMobile {...props} />
                        :
                        <EnvieDesktop {...props} />
                    }
                </>;
            case 'ocean':
                return <>
                    {isDesktop() ?
                        <OceanDesktop {...props} />
                        :
                        <OceanMobile {...props} />
                    }
                </>;
            case 'severnoe-siyanie':
                return <NorthernLights {...props} />;
            case 'i-wish':
                return <ViewItemBatcherProvider><Wish {...props} /></ViewItemBatcherProvider>;
            case 'zhivaya-skazka':
                return <Story {...props} />;
            case 'minima':
                return <Minima {...props} />;
            default:
                return null;
        }
    };

    return (
        <BaseLayout {...props}>
            <DetailedStart />
        </BaseLayout>
    );
}

export default Index;
